<template>

    <TemplateBasic 
      v-bind:breadcrumb="breadcrumb"
      v-bind:permission="permission">

      <div class="row form-group">

        <div class="col">
          <AppAddButton v-bind:permission="permission">
          <a @click.prevent="onAddButtonClick" class="btn btn-rounded btn-block-xs-only" style="background: rgb(38, 198, 218); color: #fff;">
            Add Street
          </a>
          </AppAddButton>
        </div>

        <AppSearch 
          ref="pageSearch"
          class="col-md-4"
          v-on:search-data-change="onSearchChange" />
        
      </div>

      <AppFilter 
        ref="carparkFilter" 
        filterKey="carparkID"
        v-on:filter-data-change="onFilterCarparkChange" />

      <AppFilter 
        ref="zoneFilter" 
        filterKey="zoneID"
        v-show="zoneFilterVisible"
        v-bind:filterEmptyMessage="'No car park zone data available'"
        v-on:filter-data-change="onFilterZoneChange" />
      
      <AppTable 
        ref="pageTable" 
        v-bind:tableParameter="PARAM" 
        v-bind:permission="permission"
        v-on:table-data-click="onTableDataClick" 
        v-on:table-page-change="onTablePageChange" />

      <TemplateFeedback ref="pageFeedback" />
      
      <AppModalForm 
        ref="pageModal" 
        v-bind:formParameter="PARAM" 
        v-bind:permission="permission"
        v-on:modal-data-add="onModalAddDataClick"
        v-on:modal-data-edit="onModalEditDataClick"
        v-on:modal-data-delete="onModalDeleteDataClick" />

    </TemplateBasic>

</template>

<script>
import TemplateBasic from "@/components/Template/TemplateBasic";
import TemplateButton from "@/components/Template/TemplateButton";
import TemplateFeedback from "@/components/Template/TemplateFeedback";
import AppSearch from "@/components/App/AppSearch";
import AppPaging from "@/components/App/AppPaging";
import AppFilter from "@/components/App/AppFilter";
import AppTable from "@/components/App/AppTable";
import AppAddButton from "@/components/App/AppAddButton";
import AppModalForm from "@/components/App/AppModalForm";
import validation from "@/components/Utility/Validation"
import helper from "@/components/Utility/Helper"

var querystring = require('querystring');

const PARAM = [
  {
    key: '_index',
    index: true,
  },
  {
    key: 'carparkID',
    text: 'Car Park',
    table_hide: true,
    form_select: [],
    form_chosen: true,
    form_add_input_attr: {
      disabled: true,
    },
    form_edit_hide: true,
    form_edit_input_attr: {
      disabled: true,
    },
    form_edit_validation: [],
  },
  {
    key: 'zoneID',
    text: 'Zone',
    table_hide: true,
    form_select: [],
    form_chosen: true,
    // form_add_input_attr: {
    //   disabled: true,
    // },
    form_edit_input_attr: {
      disabled: true,
    }
  },
  {
    key: 'name',
    text: 'Street Name',
    table_popup: true, 
  },
  {
    key: 'ReservedCount',
    table_head: 'Reserved',
    text: 'Reserved Bay Count',
    form_default: 0,
    form_input_attr: {
      'type': 'Number',
    },
  },
  {
    key: 'TandemCount',
    table_head: 'Tandem-Reserved',
    text: 'Tandem-Reserved Bay Count',
    form_default: 0,
    form_input_attr: {
      'type': 'Number',
    },
  },
  {
    key: 'NonReservedCount',
    table_head: 'Non-Reserved',
    text: 'Non-Reserved Bay Count',
    form_default: 0,
    form_input_attr: {
      'type': 'Number',
    },
  },
  {
    key: 'MotorcycleCount',
    table_head: 'Motorcycle',
    text: 'Motorcycle Bay Count',
    form_default: 0,
    form_input_attr: {
      'type': 'Number',
    },
  },
  {
    key: 'VisitorCount',
    table_head: 'Visitor',
    text: 'Visitor Bay Count',
    form_default: 0,
    form_input_attr: {
      'type': 'Number',
    },
  },
  {
    key: '_total',
    text: 'Total',
    table_custom: function(dataResult, dataIndex, dataParameter, parameterIndex) {
      let parameterItem = dataParameter[parameterIndex];
      let dataItem = dataResult[dataIndex];
      return dataItem.ReservedCount + dataItem.TandemCount + dataItem.NonReservedCount + dataItem.MotorcycleCount + dataItem.VisitorCount;
    },
    form_hide: true,
    form_input_validation: [],
  },
];

const PARAM_MAP = helper.transformParamToMap(PARAM);

export default {
  name: "PageStreet",
  components: {
    TemplateBasic,
    TemplateButton,
    AppSearch,
    AppPaging,
    AppFilter,
    AppTable,
    AppAddButton,
    AppModalForm,
    TemplateFeedback,
  },
  data () {
    return {
      permission : null,
      breadcrumb : [
        { name: 'Home', url: helper.WEB_URL },
        { name: 'Car Park', url: '/carpark' },
        { name: 'Zone', url: '/zone' },
        { name: 'Street' },
      ],

      PARAM,
      PARAM_MAP,

      zoneFilterVisible: false,
    }
  },
  mounted() {
    if(!helper.hasViewPermission(this.permission = helper.getPermission(this))) {
      return;
    }
    
    this.$refs['carparkFilter'].formatFilterOptionText = (dataItem) => dataItem.carparkCode ? `${dataItem.carparkCode} - ${dataItem.name}` : dataItem.name;
    this.loadCarpark();
  },
  methods: {
    loadCarpark() {
      this.$refs['pageTable'].setTableData(null);
      this.$refs['carparkFilter'].setFilterLoading('Loading car park data...');

      this.$http
        .get(
          helper.SERVER_URL + '/api2/carpark',
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          this.$refs['carparkFilter'].setFilterDataWithValueIfFirstLoad(response.data, this.$route.query.carparkID);
          // this.$refs['carparkFilter'].setFilterDataWithValueIfFirstLoad([].concat({name: 'All Car Parks'}, response.data), this.$route.query.carparkID);
          helper.inputSelectSetOption(this.PARAM_MAP['carparkID'], response.data);

          if(response.data && response.data.length > 0) {
            this.onFilterCarparkChange();
          }
        })
        .catch(error => {
          this.$refs['carparkFilter'].setFilterError(helper.parseAxiosErrorMessage(this, error, 'loading', 'car park data'));
        });
    },
    loadZone() {
      this.$refs['pageTable'].setTableData(null);
      this.$refs['zoneFilter'].setFilterLoading('Loading zone data...');

      let url = helper.SERVER_URL + '/api2/zone';
      let carparkFilter = this.$refs['carparkFilter'].filterValue;
      if(carparkFilter) {
        url = helper.SERVER_URL + `/api2/carpark/${carparkFilter}/zone`;
      }

      this.$http
        .get(
          url,
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          // this.$refs['zoneFilter'].setFilterDataWithValueIfFirstLoad(response.data, this.$route.query.zoneID);
          this.$refs['zoneFilter'].setFilterDataWithValueIfFirstLoad([].concat({name: 'All Zone'}, response.data), this.$route.query.zoneID);
          helper.inputSelectSetOption(this.PARAM_MAP['zoneID'], response.data);

          if(response.data && response.data.length > 0) {
            this.onFilterZoneChange();
          }
        })
        .catch(error => {
          this.$refs['zoneFilter'].setFilterError(helper.parseAxiosErrorMessage(this, error, 'loading', 'zone data'));
        });
    },
    loadData() {
      this.$refs['pageTable'].setTableLoading();

      let url = this.getUrl(this.$refs['carparkFilter'].filterValue, this.$refs['zoneFilter'].filterValue);
      url = helper.appendSearchQuery(url, this.$refs['pageSearch'].searchValue);
      url = helper.appendPagingQuery(url, this.$refs['pageTable'].getCurrentPage());
      
      this.$http
        .get(
          url,
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response, true);
          response.data.forEach(k => {
            k['carparkID'] = (helper.inputSelectFindOption(PARAM_MAP['zoneID'], k['zoneID']) || {}).carparkID;
          });
          this.$refs['pageTable'].setTableData(response.data, this.$refs['pageTable'].getCurrentPage());
        })
        .catch(error => {
          this.$refs['pageTable'].setTableError(helper.parseAxiosErrorMessage(this, error, 'loading', 'street data'));
        })
    },

    getUrl(carparkID, zoneID) {
      let url = helper.SERVER_URL + '/api2';
      url += '/street/?1=1';
      if(carparkID) {
        url += '&carparkID=' + carparkID;
        if(zoneID) {
          url += '&zoneID=' + zoneID;
        }
      }

      return url;
    },

    onTablePageChange() {
      this.loadData();
    },
    onSearchChange(dataIndex) {
      this.$refs['pageTable'].setCurrentPage(1);
      this.loadData();
    },
    onFilterCarparkChange(dataIndex) {
      this.$refs['pageTable'].setCurrentPage(1);
      if(this.$refs['carparkFilter'].filterValue) {
        this.zoneFilterVisible = true;
        this.loadZone();
      } else {
        this.zoneFilterVisible = false;
        this.loadData();
      }
    },
    onFilterZoneChange() {
      this.$refs['pageTable'].setCurrentPage(1);
      this.loadData();
    },

    onAddButtonClick() {
      this.$refs['pageFeedback'].setFeedbackMessage();
      
      let defaultData = this.$refs['pageModal'].$refs['modalForm'].getFormDefaultData();
      defaultData['carparkID'] = this.$refs['carparkFilter'].filterValue;
      defaultData['zoneID'] = this.$refs['zoneFilter'].filterValue;

      this.$refs['pageModal'].setModalOpen(true, 'Add New Car Park Street', defaultData);
    },
    onTableDataClick(tableData, tableDataIndex) {
      this.$refs['pageFeedback'].setFeedbackMessage();
      this.$refs['pageModal'].setModalOpen(false, 'Edit ' + tableData[tableDataIndex]['name'], tableData[tableDataIndex]);
    },

    onModalAddDataClick(selectedData) {
      this.$refs['pageModal'].setModalLoading('Adding ' + selectedData.name);
      
      this.$http
        .post(
          this.getUrl(selectedData.carparkID, selectedData.zoneID),
          querystring.stringify(selectedData),
          helper.createAxiosFormConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          this.$refs['carparkFilter'].setFilterValue(selectedData.carparkID);
          this.$refs['zoneFilter'].setFilterValue(selectedData.zoneID);
          this.upsertDataComplete('Successfully added ' + selectedData.name);
        })
        .catch(error => {
          this.$refs['pageModal'].setModalError(helper.parseAxiosErrorMessage(this, error, 'adding', 'data'));
        })
    },
    onModalEditDataClick(selectedData) {
      this.$refs['pageModal'].setModalLoading('Updating ' + selectedData.name);
      this.$http
        .put(
          helper.SERVER_URL + '/api2/street/' + selectedData.id,
          // this.getUrl(selectedData.carparkID, selectedData.zoneID) + selectedData.id,
          // this.getUrl(this.$refs['carparkFilter'].filterValue, this.$refs['zoneFilter'].filterValue) + selectedData.id,
          querystring.stringify(selectedData),
          helper.createAxiosFormConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          this.upsertDataComplete('Successfully update ' + selectedData.name);
        })
        .catch(error => {
          this.$refs['pageModal'].setModalError(helper.parseAxiosErrorMessage(this, error, 'updating', 'data'));
        })
    },
    onModalDeleteDataClick(selectedData) {
      this.$refs['pageModal'].setModalLoading('Deleting ' + selectedData.name);

      this.$http
        .delete(
          helper.SERVER_URL + '/api2/street/' + selectedData.id,
          // this.getUrl(selectedData.carparkID, selectedData.zoneID) + selectedData.id,
          // this.getUrl(this.$refs['carparkFilter'].filterValue, this.$refs['zoneFilter'].filterValue) + selectedData.id,
          helper.createAxiosFormConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          this.upsertDataComplete('Successfully delete ' + selectedData.name);
        })
        .catch(error => {
          this.$refs['pageModal'].setModalError(helper.parseAxiosErrorMessage(this, error, 'deleting', 'data'));
        })
    },
    upsertDataComplete(message) {
      this.$refs['pageModal'].setModalClose();
      this.$refs['pageFeedback'].setFeedbackMessage(message);
      this.loadData();
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Page/CarPark/PageStreet.vue